import { createQueryStore as createQueryStore$1 } from "@sanity/core-loader";
import { useEffect, useMemo, useState, useSyncExternalStore } from "react";
import { defineEncodeDataAttribute } from "@sanity/core-loader/encode-data-attribute";
function defineStudioUrlStore(client) {
  let studioUrl = typeof client == "object" ? client?.config().stega.studioUrl : void 0;
  const serverSnapshot = studioUrl, subscribers = /* @__PURE__ */ new Set();
  return {
    subscribe(callback) {
      return subscribers.add(callback), () => subscribers.delete(callback);
    },
    getSnapshot() {
      return studioUrl;
    },
    getServerSnapshot() {
      return serverSnapshot;
    },
    setStudioUrl(nextStudioUrl) {
      studioUrl = nextStudioUrl, subscribers.forEach((callback) => callback());
    }
  };
}
function defineUseLiveMode({
  enableLiveMode,
  setStudioUrl
}) {
  return ({ allowStudioOrigin, client, onConnect, onDisconnect, onPerspective, studioUrl }) => {
    useEffect(() => {
      allowStudioOrigin && console.warn("`allowStudioOrigin` is deprecated and no longer needed");
      const disableLiveMode = enableLiveMode({
        client,
        onConnect,
        onDisconnect,
        onPerspective
      });
      return () => disableLiveMode();
    }, [allowStudioOrigin, client, onConnect, onDisconnect, onPerspective]), useEffect(() => {
      setStudioUrl(
        studioUrl ?? typeof client == "object" ? client?.config().stega.studioUrl : void 0
      );
    }, [studioUrl, client]);
  };
}
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x.default : x;
}
var fastDeepEqual, hasRequiredFastDeepEqual;
function requireFastDeepEqual() {
  return hasRequiredFastDeepEqual || (hasRequiredFastDeepEqual = 1, fastDeepEqual = function equal(a, b) {
    if (a === b) return !0;
    if (a && b && typeof a == "object" && typeof b == "object") {
      if (a.constructor !== b.constructor) return !1;
      var length, i, keys;
      if (Array.isArray(a)) {
        if (length = a.length, length != b.length) return !1;
        for (i = length; i-- !== 0; )
          if (!equal(a[i], b[i])) return !1;
        return !0;
      }
      if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
      if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
      if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
      if (keys = Object.keys(a), length = keys.length, length !== Object.keys(b).length) return !1;
      for (i = length; i-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return !1;
      for (i = length; i-- !== 0; ) {
        var key = keys[i];
        if (!equal(a[key], b[key])) return !1;
      }
      return !0;
    }
    return a !== a && b !== b;
  }), fastDeepEqual;
}
var fastDeepEqualExports = requireFastDeepEqual(), isEqual = /* @__PURE__ */ getDefaultExportFromCjs(fastDeepEqualExports);
function useEncodeDataAttribute(result, sourceMap, studioUrl) {
  return useMemo(
    () => defineEncodeDataAttribute(result, sourceMap, studioUrl),
    [result, sourceMap, studioUrl]
  );
}
function defineUseQuery({
  createFetcherStore,
  studioUrlStore
}) {
  const DEFAULT_PARAMS = {};
  return (query, params = DEFAULT_PARAMS, options = {}) => {
    const initial = useMemo(
      () => options.initial ? { perspective: "published", ...options.initial } : void 0,
      [options.initial]
    ), $params = useMemo(() => JSON.stringify(params), [params]), [snapshot, setSnapshot] = useState(() => createFetcherStore(
      query,
      JSON.parse($params),
      initial
    ).value);
    useEffect(() => {
      const unlisten = createFetcherStore(
        query,
        JSON.parse($params),
        initial
      ).subscribe((snapshot2) => {
        setSnapshot((prev) => !isEqual(prev.sourceMap, snapshot2.sourceMap) || !isEqual(prev.data, snapshot2.data) || prev.error !== snapshot2.error || prev.loading !== snapshot2.loading || prev.perspective !== snapshot2.perspective ? snapshot2 : prev);
      });
      return () => unlisten();
    }, [$params, initial, query]);
    const studioUrl = useSyncExternalStore(
      studioUrlStore.subscribe,
      studioUrlStore.getSnapshot,
      studioUrlStore.getServerSnapshot
    ), encodeDataAttribute = useEncodeDataAttribute(snapshot.data, snapshot.sourceMap, studioUrl);
    return useMemo(() => ({ ...snapshot, encodeDataAttribute }), [snapshot, encodeDataAttribute]);
  };
}
const createQueryStore = (options) => {
  const { createFetcherStore, enableLiveMode } = createQueryStore$1({
    tag: "react-loader",
    ...options
  }), studioUrlStore = defineStudioUrlStore(options.client), useQuery2 = defineUseQuery({ createFetcherStore, studioUrlStore }), useLiveMode2 = defineUseLiveMode({
    enableLiveMode,
    setStudioUrl: studioUrlStore.setStudioUrl
  });
  return {
    loadQuery: () => {
      throw new Error("The `loadQuery` function is server only.");
    },
    // @ts-expect-error - update typings
    useQuery: useQuery2,
    setServerClient: () => {
      throw new Error("The `setServerClient` function is server only.");
    },
    useLiveMode: useLiveMode2
  };
}, { loadQuery, setServerClient, useLiveMode, useQuery } = createQueryStore({
  client: !1,
  ssr: !0
});
export {
  createQueryStore,
  loadQuery,
  setServerClient,
  useEncodeDataAttribute,
  useLiveMode,
  useQuery
};
//# sourceMappingURL=index.browser.js.map
